import { defineStore } from 'pinia'
import axios from 'axios'
import Cookies from 'js-cookie'
import blankAvatar from '@/assets/images/blank-profile-avatar.png'

const root_api_url = process.env.VUE_APP_API_ROOT_URL
// const rid = this.profile?.roleId

export const useUserStore = defineStore('user', {
  state: () => ({
    token: Cookies.get('auth_token') || null,
    profile: null,
    profilePhoto: blankAvatar,
    profileSignature: '',
  }),

  getters: {
    isLoggedIn: (s) => !!s.token,
    uuid: (s) => s.profile?.uuid,
    avatar: (s) => s.profilePhoto,
    rid: (s) => s.profile?.roleId,
    bizClientId: (s) => s.profile?.role?.bizClientId ?? s.profile?.bizClientId ?? 0,
    groupTypeId: (s) => s.profile?.groupTypeId ?? null,
    groupHeadId: (s) => s.profile?.groupHeadId ?? null,
    groupMemberId: (s) => s.profile?.groupMemberId ?? null,
    groupProfileId: (s) => s.profile?.groupMemberId ?? s.profile?.groupHeadId ?? null,
    signature: (s) => s.profileSignature,
    hasRealPhoto: (s) => s.profilePhoto !== blankAvatar,
  },

  actions: {
    setToken(token) {
      this.token = token
      Cookies.set('auth_token', token) // Persist to cookie
    },

    async fetchProfile() {
      const token = Cookies.get('auth_token')
      try {
        const res = await axios.get(`${root_api_url}/auth/user/me`, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          }
        })
        this.profile = {
          ...res.data,
          groupTypeId: res.data?.groupTypeId ?? null,
          groupHeadId: null,
          groupMemberId: null,
        }
        await this.fetchRole(this.profile.roleId)
        await this.fetchGroupProfileData()
        console.log('Profile fetched:', this.profile)
        return this.profile
      } catch (error) {
        console.error('Failed to fetch profile:', error)
        throw error
      }
    },

    async fetchGroupProfileData() {
      const token = Cookies.get('auth_token')
      const userId = this.profile?.id || this.profile?.uuid

      if (!token || !this.profile || !userId) {
        return this.profile
      }

      const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }

      const isGroupHead = !!this.profile?.role?.groupHead
      const isGroupMember = !!this.profile?.role?.groupMember

      this.profile.groupHeadId = null
      this.profile.groupMemberId = null

      if (isGroupHead) {
        try {
          const response = await axios.get(`${root_api_url}/eli/group-head/user/${userId}`, { headers })
          this.profile.groupHeadId = response.data?.id ?? null
          this.profile.groupTypeId = response.data?.groupTypeId ?? this.profile.groupTypeId ?? null
        } catch (error) {
          if (error?.response?.status !== 404) {
            console.error('Failed to fetch group head profile:', error)
          }
        }
      }

      if (isGroupMember) {
        try {
          const response = await axios.get(`${root_api_url}/eli/group-head/group-member/user/${userId}`, { headers })
          this.profile.groupMemberId = response.data?.id ?? null
          this.profile.groupTypeId = response.data?.groupTypeId ?? this.profile.groupTypeId ?? null
        } catch (error) {
          if (error?.response?.status !== 404) {
            console.error('Failed to fetch group member profile:', error)
          }
        }
      }

      return this.profile
    },

    async fetchProfilePhoto() {
      const token = Cookies.get('auth_token')
      try {
        const response = await axios.get(`${root_api_url}/auth/user/photo`, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          }
        });
        this.profilePhoto = response.data.imageContent
          ? `data:image/png;base64,${response.data.imageContent}`
          : blankAvatar;

          this.hasRealPhoto = !!response.data.imageContent
        // this.profilePhoto = response.data
        // console.log("avatar this:", this.profilePhoto)
        return response.data;
      } catch (error) {
        console.error('Error fetching profile photo:', error)
        this.profilePhoto = blankAvatar
        return this.profilePhoto
      }
    },

    async fetchRole(rid) {
      const token = Cookies.get('auth_token')
      try {
        const response = await axios.get(`${root_api_url}/auth/role/${rid}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          }
        });
        this.profile.role = response.data
        // console.log('Role fetched:', this.profile.role)
      } catch (error) {
        console.error('Error fetching role:', error)
      }
    },

    async fetchSignature() {
      const token = Cookies.get('auth_token')
      this.profileSignature = '';
      try {
        const response = await axios.get(`${root_api_url}/auth/user/sign`, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          }
        });
        this.profileSignature = response.data.imageContent
          ? `data:image/png;base64,${response.data.imageContent}`
          : '';
        // console.log('Signature fetched:', this.profileSignature)
        return response.data;
      } catch (error) {
        console.error('Error fetching signature:', error)
      }
    },
    // async login(credentials) {
    //   try {
    //     const res = await axios.post(`${root_api_url}/auth/login`, credentials, {
    //       headers: { 'Content-Type': 'application/json' }
    //     })
    //     const token = res.data?.token
    //     if (token) {
    //       this.setToken(token)
    //       await this.fetchProfile()
    //     }
    //   } catch (error) {
    //     console.error('Login failed:', error)
    //     throw error
    //   }
    // },

    logout() {
      this.token = null
      this.profile = null
      this.profilePhoto = blankAvatar
      this.profileSignature = ''
      Cookies.remove('auth_token')
    }
  }
})
